import AuditLogItem from './AuditLogItem';

export default AuditLogItem;
